export default __webpack_public_path__ + "static/media/deban.a35c6103.jpg";